import { createRouter, createWebHistory } from 'vue-router'
import { auth } from '@/firebaseConfig'
import { onAuthStateChanged } from 'firebase/auth'
import { useCustomerDetailsStore } from '@/stores/customerDetails'
import { usePriceStore } from '@/stores/servicePriceStore'


const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
    component: () => import('../views/PlaceOrderView.vue'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/AboutView.vue'),
    },
    {
      path: '/podsumowanie',
      name: 'summary',
      component: () => import('../views/PurchaseSummary.vue'),
      beforeEnter: (to, from) => {
        if (!from.name) {
          return { name: 'home' }
        }
      },
    },
    {
      path: '/podsumowanie/:id',
      name: 'editDummary',
      component: () => import('../views/PurchaseSummary.vue'),
      beforeEnter: (to, from) => {
        if (!from.name) {
          return { name: 'home' }
        }
      },
    },
    {
      path: '/logowanie',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
    },
    {
      path: '/sukces/:id',
      name: 'success',
      component: () => import('@/views/SuccessView.vue'),
    },
    {
      path: '/sukces',
      name: 'successWithoutId',
      redirect: '/konto/zamowienia',
    },
    {
      path: '/admin',
      name: 'admin',
      component: () => import('../views/AccountView.vue'),
      children: [
        {
          path: 'zamowienia',
          name: 'adminOrders',
          component: () => import('../views/MyOrdersView.vue'),
        },
        {
          path: 'zamowienia/:id',
          name: 'adminOrderDetails',
          component: () => import('../views/OrderDetailsView.vue'),
        },
        {
          path: 'zamowienia/:id/anuluj',
          name: 'adminCancelOrder',
          component: () => import('../views/CancelOrderView.vue'),
        },
        {
          path: 'wyloguj',
          name: 'adminLogout',
          component: () => import('@/views/LogoutView.vue'),
        },
      ]
    },
    {
      path: '/konto/zamowienia/cykliczne/:id/edytuj', 
      name: 'reucrringOrderEdit',
      component: () => import('../views/EditOrdersView.vue'),
    },
    {
      path: '/konto',
      name: 'account',
      component: () => import('../views/AccountView.vue'),
      children: [
        {
          path: 'zamowienia',
          name: 'orderHistory',
          component: () => import('../views/MyOrdersView.vue'),
        },
        {
          path: 'zamowienia/:id',
          name: 'orderDetails',
          component: () => import('../views/OrderDetailsView.vue'),
        },
        {
          path: '/konto/zamowienia/:id/anuluj',
          name: 'cancelOrder',
          component: () => import('../views/CancelOrderView.vue'),
        },

        {
          path: 'wyloguj',
          name: 'logout',
          component: () => import('@/views/LogoutView.vue'),
        },
        {
          path: 'usun',
          name: 'deleteAccount',
          component: () => import('@/views/DeleteAccountView.vue'),
        },
      ],
    },
  ],
})

// Navigation guard with auth state check
router.beforeEach((to, from, next) => {
  const getCurrentUser = new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(
      auth,
      user => {
        unsubscribe()
        resolve(user)
      },
      error => {
        unsubscribe()
        reject(error)
      },
    )
  })

  getCurrentUser
    .then(user => {
      // Access the store
      const customerDetailsStore = useCustomerDetailsStore()
      const priceStore = usePriceStore()

      // Define the target routes
      const targetRoutes = ['cleaning-standard', 'cleaning-office', 'cleaning-window', 'cleaning-renovation'];

      // Check if the route name is in the target routes array
      if (targetRoutes.includes(to.name)) { 
        customerDetailsStore.setEditingMode(false); 
        if (!from.path.includes('/podsumowanie')) {
          priceStore.resetAllFields(to.name)
        }
      }

      if (to.name === 'login' && user) {
        next({ name: 'home' })
      } else if (to.path.startsWith('/konto')) {
        if (user) {
          next()
        } else {
          next({ name: 'login' })
        }
      } else {
        next()
      }
    })
    .catch(() => {
      next()
    })
})

export default router
